/* eslint-disable react/jsx-indent-props */
import { useContext } from "react";
import { rootStoreContext } from "./store/root";

export const useStores = () => useContext(rootStoreContext);
